// extracted by mini-css-extract-plugin
export default {"file":"InputFile_file__gAW0d","inputPersonalizado":"InputFile_inputPersonalizado__fGJ5h","inputFile":"InputFile_inputFile__O607f"};